import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import {
  DynamicField,
  DynamicFieldValue,
} from 'shared/api/kyrgyzstan/search/model'
import { Paper } from 'shared/ui/paper'

import { DynamicFields } from '../../../../../widgets/kyrgyzstan/detail-content/ui/head-section/ui/dynamic-fields'

import s from './styles.module.scss'

interface AmenitiesSectionProps {
  popularDynamicFields: DynamicField[]
  dynamicFields: DynamicFieldValue
  realtyId: string
}

export const AmenitiesSection = ({
  popularDynamicFields,
  dynamicFields,
  realtyId,
}: AmenitiesSectionProps) => {
  const { t } = useTranslation()

  if (popularDynamicFields.length === 0 && dynamicFields.count === 0) {
    return null
  }

  return (
    <Paper
      padding={[12, 14]}
      radius="16"
    >
      <h2 className={clsx('bold-14', s.sectionTitle)}>
        {t('kyrgyzstan_block.option_detail.room_amenities')}
      </h2>
      <DynamicFields
        popularDynamicFields={popularDynamicFields}
        dynamicFields={dynamicFields}
        realtyId={realtyId}
      />
    </Paper>
  )
}
